<div [ngClass]="classes" [class.in-invalid]="!!error">
  <ng-container *ngIf="buttonTemplate">
    <ng-container
      *ngTemplateOutlet="
        buttonTemplate;
        context: {
          id: this.id,
          nameProp: this.nameProp,
          selected: this.selected
        }
      "
    ></ng-container>
  </ng-container>

  <ng-container *ngIf="!buttonTemplate">
    <ng-container
      *ngTemplateOutlet="
        defaultTemplate;
        context: {
          id: this.id,
          nameProp: this.nameProp,
          selected: this.selected
        }
      "
    ></ng-container>
  </ng-container>

  <ng-template
    #defaultTemplate
    let-id="id"
    let-nameProp="nameProp"
    let-selected="selected"
  >
    <button
      class="btn btn-form-control dropdown-toggle btn-block"
      [class.is-invalid]="!!error || wrong"
      type="button"
      [id]="id + '-toggle'"
      data-toggle="dropdown"
      data-flip="false"
      data-display="static"
      aria-haspopup="true"
      [attr.aria-controls]="id"
    >
      <ng-container *ngIf="phTemplate && selected">
        <ng-container
          *ngTemplateOutlet="
            phTemplate;
            context: { nameProp: this.nameProp, selected: this.selected }
          "
        ></ng-container>
      </ng-container>

      <ng-container *ngIf="!phTemplate || !selected">
        <ng-container
          *ngTemplateOutlet="
            phDefaultTemplate;
            context: {
              placeholder: this.placeholder,
              selected: this.selected,
              nameProp: this.nameProp
            }
          "
        ></ng-container>
      </ng-container>
    </button>
  </ng-template>

  <ng-template
    #phDefaultTemplate
    let-placeholder="placeholder"
    let-selected="selected"
    let-nameProp="nameProp"
  >
    <ng-container *ngIf="selected">
      {{ selected[nameProp] }}
    </ng-container>

    <ng-container *ngIf="!selected">{{ placeholder }}</ng-container>
  </ng-template>

  <div
    class="dropdown-menu dropdown-menu-lender"
    *ngIf="items.length > 0"
    [attr.aria-labelledby]="id + '-toggle'"
    [id]="id"
  >
    <ng-container
      *ngTemplateOutlet="
        searchTemplate;
        context: {
          title: this.titleSearch,
          subtitle: this.subtitleSearch,
          nameProp: this.nameProp,
          valueProp: this.valueProp,
          items: this.items,
          filter: this.filter,
          clear: this.clear
        }"
    ></ng-container>

    <!-- [viewClass]="'custom-scrollbar'" -->
    <ng-scrollbar 
      [visibility]="'hover'"
      class="scroll-height custom-scrollbar"
    >
      <!-- [minThumbSize]="30" -->
      <ng-container *ngFor="let item of items; trackBy: dropdownTrackBy">
        <ng-container
          *ngTemplateOutlet="
            optionTemplate;
            context: {
              $implicit: item,
              select: this.select,
              selected: this.selected,
              nameProp: this.nameProp,
              valueProp: this.valueProp
            }
          "
        ></ng-container>
      </ng-container>
    </ng-scrollbar>
  </div>
  <div class="invalid-feedback" *ngIf="error">
    {{ this.error }}
  </div>
</div>
